import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AngularFireDatabase } from 'angularfire2/database';
import swal from 'sweetalert2';
import * as firebase from'firebase/app';
import { NgProgress } from 'ngx-progressbar';
import { NgbDatepickerConfig } from '@ng-bootstrap/ng-bootstrap';
import { AssignmentAlgorithmService } from '../algorithm/assignment-algorithm.service';
import { DateService } from 'app/date/date.service';
import { NotificationToastService } from 'app/notification/notification-toast.service';

@Component({
  selector: 'app-add-shipment',
  templateUrl: './add-shipment.component.html',
  styleUrls: ['./add-shipment.component.css'],
  providers:[NotificationToastService, AngularFireDatabase, AssignmentAlgorithmService,DateService]
})
export class AddShipmentComponent implements OnInit {
  myForm: FormGroup;
  myFormItem: FormGroup;
  submitted: boolean = false;
  submittedItem: boolean = false;
  items:any;
  total: number;
  editId:number;
  editing = {};
  private lastId = 1000000;
  isAutomatic: any;
  cities:any;
  citiyList:any;
  today: any;
  time:any;
  constructor(private db: AngularFireDatabase, private nf: NotificationToastService, private ngProgress: NgProgress, private config: NgbDatepickerConfig, private algorithm: AssignmentAlgorithmService, private dateService: DateService) { 
    this.initializeForm();
    this.initializeItemForm();

    const currentDate = new Date();

    config.minDate = {year:currentDate.getFullYear(), month:currentDate.getMonth()+1, day: currentDate.getDate()};
    config.maxDate = {year: 2099, month: 12, day: 31};
    config.outsideDays = 'hidden';
  }
  ngOnInit() {
    this.items = [];
    this.getShipmentId();
    this.getCities();
    firebase.database().ref("autoAssign").on("value",(data)=>{
      this.isAutomatic = data.val();
    });
  }
  getShipmentId()
  {
    const d = this.db.list('/shipments', ref => ref.orderByKey().limitToLast(1)).valueChanges();
    d.subscribe(data=>{
      data.forEach(d=>{
        /* var year = (String(d["id"])).substring(0, 4);
        var date = new Date();
        var currentYear = date.getFullYear();
        if(year==String(currentYear)) {
          this.lastId = d["id"] + 1 ;
        } else {
          this.lastId = parseInt(currentYear+"00000000");
        } */
        this.lastId = d["id"] + 1 ;
      });
    });
  }
  getCities()
  {
    var city = this.db.list("cities");
    city.snapshotChanges().subscribe(item=>{
    this.cities = [];
    this.citiyList = [];
    item.forEach(element =>{
      var y = element.payload.toJSON();
        y["$key"] = element.key;
        this.cities.push(y);
        this.citiyList[element.key] = element.payload.toJSON();
    });
  });
  }
  initializeForm()
  {
    this.myForm = new FormGroup({
      sourceName: new FormControl('', Validators.required),
      sourceCode: new FormControl('', Validators.required),
      sourcePhone: new FormControl('', Validators.required),
      sourceAddress1: new FormControl(''),
      sourceAddress2: new FormControl(''),
      sourceCity: new FormControl('', Validators.required),
      pickupDate: new FormControl(''),
      destinationName: new FormControl('', Validators.required),
      destinationCode: new FormControl('', Validators.required),
      destinationPhone: new FormControl('', Validators.required),
      destinationAddress1:new FormControl(''),
      destinationAddress2: new FormControl(''),
      destinationCity: new FormControl('', Validators.required),
      deliveryDate: new FormControl(''),
      sourcePincode: new FormControl(''),
      destinationPincode: new FormControl('')
    });
    this.myForm.reset();
    this.myForm.controls["sourceCode"].setValue('+966');
    this.myForm.controls["destinationCode"].setValue('+966');
  }
  initializeItemForm()
  {
    this.myFormItem = new FormGroup({
      item:  new FormControl('', Validators.required),
      quantity: new FormControl('', Validators.required),
      description: new FormControl('', Validators.required),
      price: new FormControl('', Validators.required),
    });
  }
  phone_error1:boolean = false;
  phone_error2:boolean = false;
  async onSubmit()
  {
    this.submitted = true;
    this.total = 0;
    var items = [];
    this.items.forEach(i=>{
      this.total = this.total + (parseInt(i.price) * parseInt(i.quantity));
      items.push({
        id: i.id,
        item: i.item,
        description: i.description,
        quantity: i.quantity,
        price: i.price,
        total: i.total
      });
    });
    this.phone_error1 = false;
    this.phone_error2 = false;
    var phone1 = this.myForm.value.sourcePhone;
    var phone2 = this.myForm.value.destinationPhone;
    if(phone1.length != this.maxLength1)
      {
        this.phone_error1 = true;
        return;
      }
      else if(phone2.length != this.maxLength2)
      {
        this.phone_error2 = true;
        return;
      }
    else if(this.myForm.valid)
    {
      this.ngProgress.start();
      
    setTimeout(() => {
      let source = {
        name : this.myForm.value.sourceName,
        code: this.myForm.value.sourceCode,
        phoneNumber : this.myForm.value.sourcePhone,
        addressLine1 : this.myForm.value.sourceAddress1,
        addressLine2: this.myForm.value.sourceAddress2,
        date:this.myForm.value.pickupDate,
        pincode:this.citiyList[this.myForm.value.sourceCity].pincode,
        city:this.citiyList[this.myForm.value.sourceCity].name,
        lat:this.citiyList[this.myForm.value.sourceCity].lat,
        lng:this.citiyList[this.myForm.value.sourceCity].lng,
        cityId: this.myForm.value.sourceCity
      }
      let destination = {
        name : this.myForm.value.destinationName,
        code: this.myForm.value.destinationCode,
        phoneNumber : this.myForm.value. destinationPhone,
        addressLine1:this.myForm.value.destinationAddress1,
        addressLine2: this.myForm.value.destinationAddress2,
        date:this.myForm.value.deliveryDate,
        city:this.citiyList[this.myForm.value.destinationCity].name,
        pincode:this.citiyList[this.myForm.value.destinationCity].pincode,
        lat:this.citiyList[this.myForm.value.destinationCity].lat,
        lng:this.citiyList[this.myForm.value.destinationCity].lng,
        cityId: this.myForm.value.destinationCity
      }
        var lastid = String(this.lastId);
        var date_time = this.dateService.getTimeandDate();
          this.db.list('shipments').set(lastid,{
            id: this.lastId,
            source:source,
            destination:destination,
            createdAt: date_time.date,
            createdTime: date_time.time,
            createdAtTimeStamp: date_time.timeStamp,
            items: items,
            total: this.total,
            status: 1
          }).then(()=>{
            this.myForm.reset();
            this.myForm.controls["sourceCode"].setValue('+966');
            this.myForm.controls["destinationCode"].setValue('+966');
            this.submitted = false;
            this.items = [];
            this.nf.addToast({title:'Shipment Added', msg:'New Shipment has been added', timeout: 5000, theme:'material', position:'bottom-right', type:'success'});
            this.algorithm.assignToBranch(lastid,source.lat,source.lng);
          });
    }, 1000);
    }
  }
onSubmitItem()
{
  this.submittedItem = true;
  if(this.myFormItem.valid)
  {
    this.total = 0;
    var key = firebase.database().ref("items").push().key;
    var itemTotal = this.myFormItem.value.quantity * this.myFormItem.value.price;
    this.items.push({
      id: key,
      item: this.myFormItem.value.item,
      quantity: this.myFormItem.value.quantity,
      description: this.myFormItem.value.description,
      price: this.myFormItem.value.price,
      total : itemTotal
    });
    this.myFormItem.reset();
    this.submittedItem = false;
    this.submitted = false;
    this.items.forEach(i => {
      this.total = this.total + (parseInt(i.price) * parseInt(i.quantity));
    });
    this.myForm.setControl("total", new FormControl(this.total));
  }
}

updateValue(event, cell, cellValue, row) {
  this.editing[row.$$index + '-' + cell] = false;
  this.items[row.$$index][cell] = event.target.value;
  if(cell == "quantity" || cell == "price")
  {
    this.items[row.$$index]["total"] = this.items[row.$$index]["quantity"] * this.items[row.$$index]["price"];
  }
  this.submitted = false;
  this.submittedItem = false;
    this.total = 0;
    this.items.forEach(i=>{
      this.total = this.total + (parseInt(i.price) * parseInt(i.quantity));
    });
}
deleteValue(event:Event,row)
{
  event.preventDefault();
  const index = row.$$index;
  swal({
    title: 'Are you sure?',
    text: "You won't be able to revert this!",
    type: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
    confirmButtonText: 'Yes, delete it!'
  }).then(() => {
    this.items.splice(index,1);
    this.submitted = false;
    this.submittedItem = false;
    this.total = 0;
    this.items.forEach(i=>{
      this.total = this.total + (parseInt(i.price) * parseInt(i.quantity));
    });
    swal({
      title:'Deleted!',
      text: 'Your file has been deleted.',
      type: 'success'
    });
  }).catch(swal.noop);
}
  focusOutFunction()
  {
    //console.log("my function");
  }
  maxLength1: number =9;
  maxLength2: number =9;
  onChangeSourceCountry(e)
  {
    //console.log(e.target.value);
    this.phone_error1 = false;
    switch(e.target.value)
    {
      case "+91" : this.maxLength1  = 10;
      this.myForm.controls["sourcePhone"].setValidators([Validators.minLength(10),Validators.maxLength(10)]);
      break;
      case "+966" : this.maxLength1  = 9;
      this.myForm.controls["sourcePhone"].setValidators([Validators.minLength(9),Validators.maxLength(9)]);
      break;
    }
  }
  
  onChangeDestinationCountry(e)
  {
    this.phone_error2 = false;
    switch(e.target.value)
    {
      case "+91" : this.maxLength2  = 10;
      this.myForm.controls["destinationPhone"].setValidators([Validators.minLength(10),Validators.maxLength(10)]);
      break;
      case "+966" : this.maxLength2  = 9;
      this.myForm.controls["destinationPhone"].setValidators([Validators.minLength(9),Validators.maxLength(9)]);
      break;
    }
  }
  keyPressSource(event: any) {
    const pattern = /[0-9\+\-\ ]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
    else
    {
      var phone1 = this.myForm.value.sourcePhone;
      if(phone1.length >= this.maxLength1)
      {
        event.preventDefault();
      }
    }
  }
  keyPressDestination(event: any) {
    const pattern = /[0-9\+\-\ ]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
    else
    {
      var phone2 = this.myForm.value.destinationPhone;
      if(phone2.length >= this.maxLength2)
      {
        event.preventDefault();
      }
    }
  }
  keyPress1(event)
  {
    const pattern = /[0-9\+\-\ ]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }
}



// WEBPACK FOOTER //
// E:/Office Projects/Paarsel/paarsel_business_web/paarsel_business_web/src/app/logistics-operations/add-shipment/add-shipment.component.ts